export default __webpack_public_path__ + "static/principle-sentient-dark-4fd484801cbce95fff57adba6c1a1357.png";